import { NotificationAlertOverride } from ".";
import { NotificationHandleType } from "../../Notifications";
import {
  createRequirementAction,
  createRequirementChildren,
  createRequirementTitle,
  GenericRequirementNotificationContext
} from "./helper";

export const RequirementsReRequestedPayee: NotificationAlertOverride<
  GenericRequirementNotificationContext
> = (notification, history) => {
  return {
    theme: "warning",
    icon: "alert",
    title: createRequirementTitle(
      notification,
      NotificationHandleType.RequirementsReRequestedPayee
    ),
    children: createRequirementChildren(
      notification,
      NotificationHandleType.RequirementsReRequestedPayee
    ),
    action: createRequirementAction(notification, history)
  };
};
